/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupOfficesRoutingModule } from './builder-setup-offices-routing.module';
import { OfficeDetailsComponent } from './components/office-details/office-details.component';
import { OfficeListComponent } from './components/office-list/office-list.component';
import { OfficeDetailsBusinessService } from './resources/office-details-business.service';
import { OfficeListBusinessService } from './resources/office-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupOfficesRoutingModule,
  ],
  providers: [
    OfficeListBusinessService,
    OfficeDetailsBusinessService,
  ],
  declarations: [
    OfficeListComponent,
    OfficeDetailsComponent,
  ],
})
export class BuilderSetupOfficesModule {
}
